import { MethodEnum } from '@enum/method.enum';
import { isString } from '@util/data/is-exist';

export const pythonTemplate = (
  link: string,
  headers: Record<string, string> = {},
  body: Record<string, string> = {},
  method: MethodEnum = MethodEnum.GET,
) => {
  const headersText = Object.entries(headers)
    .filter(([, value]) => isString(value))
    .map(([key, value]) => `  '${key}': '${value}'`);

  return `import requests
import json

url = "${encodeURI(link)}"

headers = {${headersText.length > 0 ? `\n${headersText.join(',\n')}\n` : ''}}

payload = json.dumps(${JSON.stringify(body, null, '\t')})

response = requests.request("${method}", url, headers=headers, data=payload)
print(response.text)`;
};
